import { render, staticRenderFns } from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=template&id=2048c180"
import script from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=style&index=0&id=2048c180&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2048c180')) {
      api.createRecord('2048c180', component.options)
    } else {
      api.reload('2048c180', component.options)
    }
    module.hot.accept("./VuesticPageNotFoundSadWallpaper.vue?vue&type=template&id=2048c180", function () {
      api.rerender('2048c180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/404-pages/VuesticPageNotFoundSadWallpaper.vue"
export default component.exports